import customerStatisticsGroupsServiceGen from "./generated/customerStatisticsGroupsServiceGen";

class customerStatisticsGroupsService extends customerStatisticsGroupsServiceGen {
}

export default customerStatisticsGroupsService;